export const COMPOSITE_CONSTS = {
    GET_CONTACT: "GET_CONTACT",
    UPDATE_CONTACT: "UPDATE_CONTACT",
};
